import { render, staticRenderFns } from "./wechatFile.vue?vue&type=template&id=760fc38d&scoped=true&"
import script from "./wechatFile.vue?vue&type=script&lang=ts&"
export * from "./wechatFile.vue?vue&type=script&lang=ts&"
import style0 from "./wechatFile.vue?vue&type=style&index=0&id=760fc38d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760fc38d",
  null
  
)

export default component.exports